import {state as initialState} from './state';
import {IReduxAction, IReduxArticlesState} from '@src/@interfaces';
import {
    ARTICLES_DELETE_ARTICLE,
    ARTICLES_PUSH_TO_LIST,
    ARTICLES_REPLACE_ARTICLE,
    ARTICLES_SET_ACTIVE_ID,
    ARTICLES_SET_ERROR_MESSAGE,
    ARTICLES_SET_LIST,
    ARTICLES_SET_NOW_LOADING
} from '@src/_redux/articles/constants';
import {
    articlesDeleteArticle,
    articlesPushToList,
    articlesReplaceArticle,
    articlesSetActiveId,
    articlesSetErrorMessage,
    articlesSetList,
    articlesSetNowLoading
} from '@src/_redux/articles/actions';

export const reducer = (state: IReduxArticlesState | undefined, action: IReduxAction): Required<IReduxArticlesState> => {
    state ??= initialState;

    switch (action.type) {
        case ARTICLES_SET_ACTIVE_ID:
            const setActiveIdPayload: ReturnType<typeof articlesSetActiveId>['payload'] = action.payload;

            return {...state, activeArticleId: setActiveIdPayload.articleId};

        case ARTICLES_SET_LIST:
            const setListPayload: ReturnType<typeof articlesSetList>['payload'] = action.payload;

            return {...state, articles: setListPayload.articles, isLoading: false, isLoaded: true};

        case ARTICLES_SET_NOW_LOADING:
            const setNowLoadingPayload: ReturnType<typeof articlesSetNowLoading>['payload'] = action.payload;

            return {...state, isLoading: setNowLoadingPayload.isLoading};

        case ARTICLES_PUSH_TO_LIST:
            const pushToListPayload: ReturnType<typeof articlesPushToList>['payload'] = action.payload;

            return {
                ...state,
                articles: [
                    ...state.articles,
                    pushToListPayload.article,
                ],
            };

        case ARTICLES_REPLACE_ARTICLE:
            const replaceArticlePayload: ReturnType<typeof articlesReplaceArticle>['payload'] = action.payload;

            return {
                ...state,
                articles: state.articles.map(item => {
                    return item.id === replaceArticlePayload.article.id ?
                        replaceArticlePayload.article :
                        item;
                }),
            };

        case ARTICLES_DELETE_ARTICLE:
            const deleteArticlePayload: ReturnType<typeof articlesDeleteArticle>['payload'] = action.payload;

            const indexToDelete = state.articles.findIndex(item => item.id === deleteArticlePayload.articleId);

            return {
                ...state,
                articles: (list => {
                    if (indexToDelete === -1) {
                        return list;
                    }

                    const newList = [...list];
                    newList.splice(indexToDelete, 1);

                    return newList;
                })(state.articles),
            };

        case ARTICLES_SET_ERROR_MESSAGE:
            const setErrorMessagePayload: ReturnType<typeof articlesSetErrorMessage>['payload'] = action.payload;

            return {...state, errorMessage: setErrorMessagePayload.errorMessage};

        default:
            return state;
    }
};
